import { memo } from 'react'
import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import * as Styled from './styled'

interface IProps {
  onOpen: () => void
  isActive?: boolean
}

const PublicAvatars: React.FC<IProps> = ({ onOpen, isActive }) => {
  return (
    <Styled.PublicAvatarsCard
      type="button"
      onClick={onOpen}
      $isActive={isActive}
      data-testid="public-avatars-card"
    >
      <Styled.Content>
        <Styled.GroupIcon />
        <Text type="h2" color="white">
          {translate(T.PUBLIC_AVATARS_LABEL)}
        </Text>
      </Styled.Content>
    </Styled.PublicAvatarsCard>
  )
}

export default memo(PublicAvatars)
